import { useMemo } from "react";
import { CloseTemplateViewConfig } from "@common/types/closeTemplateViewConfig";
import { TaskType } from "@common/types/task";
import { useUser } from "@hooks/useUser";
import { Form1099ReviewModeToggle } from "@components/tasks/TaskBody/Form1099/Form1099ReviewModeToggle";
import { FORM_1099_FILTER_TABS } from "@components/tasks/TaskBody/Form1099/form1099FilterTabs";
import { buildForm1099ReviewQueryFilters } from "@components/tasks/TaskBody/Form1099/form1099ReviewFilters";
import { CloseTemplateCounterpartyDataPreview } from "./CloseTemplateCounterpartyDataPreview";
import { BUSINESS_PREVIEW_ENTITIES } from "./dataPreview/previewEntityScope";
import {
    defaultForm1099CloseTemplateView,
    parseForm1099CloseTemplateViewConfig,
    serializeForm1099CloseTemplateViewConfig,
} from "./closeTemplateTaskViewConfig";
import { ensureForm1099Eligible1099ReviewColumn } from "./form1099ReviewColumn";

interface Props {
    viewConfig: CloseTemplateViewConfig | null;
    onViewConfigChange: (viewConfig: CloseTemplateViewConfig) => void;
}

export const CloseTemplateTaskForm1099Preview: React.FC<Props> = ({
    viewConfig,
    onViewConfigChange,
}) => {
    const user = useUser();
    const reviewQueryFilters = useMemo(
        () =>
            buildForm1099ReviewQueryFilters({
                mode: "suggested",
                userId: user.id,
            }),
        [user.id],
    );

    return (
        <CloseTemplateCounterpartyDataPreview
            taskType={TaskType.FORM_1099}
            viewConfig={viewConfig}
            onViewConfigChange={onViewConfigChange}
            parseViewConfig={parseForm1099CloseTemplateViewConfig}
            serializeView={serializeForm1099CloseTemplateViewConfig}
            normalizeView={ensureForm1099Eligible1099ReviewColumn}
            createDefaultView={defaultForm1099CloseTemplateView}
            availableFilters={FORM_1099_FILTER_TABS}
            headerActions={
                <Form1099ReviewModeToggle
                    value="suggested"
                    onValueChange={() => undefined}
                    disabled
                />
            }
            extraQueryFilters={reviewQueryFilters}
            entityScope={BUSINESS_PREVIEW_ENTITIES}
        />
    );
};
